<template>
    <button type="button" class="open-filter-modal" @click.stop.prevent="store.commit('OPEN_MODAL', {name: 'filterModal'})"><filter-icon/></button>
</template>
<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
const store = ref(useStore())

</script>
